import { useFlags } from 'launchdarkly-react-client-sdk';
import { useEffect, useState } from 'react';

import { INITIALIZATION_TIMEOUT_SECONDS } from '@/constants/launchDarkly';
import {
  readDevOverride,
  toCamelCaseKey,
} from '@/hooks/flags/useLaunchDarklyFlag.web';
import { useSettledFlagState } from '@/hooks/flags/useLaunchDarklyFlagState';
import { ldClient } from '@/providers/LaunchDarklyProvider.web';

export const useIsStandbyFlagAnswered = (flagKey: string): boolean => {
  const flags = useFlags();
  const [isInitSettled, setIsInitSettled] = useState(false);

  useEffect(() => {
    let isMounted = true;
    // The client hands LDProvider its first flags before waitUntilReady
    // settles (on success or failure), so a settled init is a real answer.
    ldClient?.waitUntilReady().then(() => {
      if (isMounted) setIsInitSettled(true);
    });
    return () => {
      isMounted = false;
    };
  }, []);

  // LDProvider renders before its client is in context, so only the module
  // `ldClient` tells "LaunchDarkly not configured" from "starting up".
  const isAnswered =
    !ldClient ||
    isInitSettled ||
    readDevOverride(toCamelCaseKey(flagKey)) !== undefined ||
    Object.keys(flags).length > 0;

  return useSettledFlagState(isAnswered, INITIALIZATION_TIMEOUT_SECONDS * 1000);
};
